export default __webpack_public_path__ + "static/media/play.f6a7dad7.svg";